export default { domain: process.env.VUE_APP_API_URL || 'http://localhost:8080' };
